import React from 'react';
import { SettingsSidebar } from '@v2/components';
import { SettingsShellProps } from './types';
import { styles } from './styles';

export const SettingsShell: React.FC<SettingsShellProps> = ({
  userName,
  userRole,
  updateCount,
  categories,
  basePath,
  onLogout,
  onOpenUpdateLog,
  children,
}) => {
  return (
    <div className={styles.shell}>
      <SettingsSidebar
        userName={userName}
        userRole={userRole}
        updateCount={updateCount}
        categories={categories}
        basePath={basePath}
        onLogout={onLogout}
        onOpenUpdateLog={onOpenUpdateLog}
      />
      <main className={styles.content}>{children}</main>
    </div>
  );
};

export type { SettingsShellProps } from './types';
export default SettingsShell;
